import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  date: new Date(),
  calendar: [],
  calendarByMonth: [],
  outStandings: [],
  detail: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
